import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    id: { type: 'number' },
    name: { type: 'string' },
    declination: {
      type: 'object',
      properties: {
        miejscownik: { type: 'string' },
        dopelniacz: { type: 'string' }
      }
    }
  },
  allOf: [validationMessages]
};
